import React from "react";
import { Link } from "react-router-dom";
import imgPlaceholder from "../../img/noImg.png";
import moment from "moment";

export default function UserSettingsCard({ users, props, filters }) {
  var content = "Loading...";

  var noContentText;
  if (filters && Object.keys(filters).length > 0) {
    noContentText = "There are no users for selected filters.";
  } else {
    noContentText = "There are no users invited. Click Add User in top right corner to add first.";
  }
  if (users && users.length > 0) {
    content = (
      <div className='portrait-grid-user'>
        {users &&
          users.map((user, index) => (
            <Link className='users' key={index} to={`/admin/users/user/${user.id}/settings`}>
              <div className='users-image'>
                <div className='fixed-ratio-div'>
                  <img
                    className='card-img-top rounded-circle'
                    src={user.img ? user.img : imgPlaceholder}
                    alt=''
                    onError={(e) => {
                      e.preventDefault();
                      e.target.onerror = null;
                      e.target.src = imgPlaceholder;
                    }}
                  />
                </div>
              </div>
              <div className='users-name'>
                <div className='users-name-value'>{`${user.first_name} ${user.last_name}`}</div>
              </div>
              <div className='users-item'>
                <div className='users-item-title'> Global:</div>
                <div className='users-item-value'>
                  {user.user_role_office && user.user_role_office.role && user.user_role_office.role.value
                    ? user.user_role_office.role.value
                    : "None"}
                </div>
              </div>
              <div className='users-item'>
                <div className='users-item-title'>Active:</div>
                <div className='users-item-value'>{user.active ? "Yes" : "No"}</div>
              </div>
              <div className='users-item'>
                <div className='users-item-title'>CV:</div>
                <div className='users-item-value'>{user.cv ? "Yes" : "No"}</div>
              </div>
              <div className='users-item'>
                <div className='users-item-title'> Login:</div>
                <div className='users-item-value'>
                  {user.last_login ? moment.utc(user.last_login).local().format("DD.MM.YYYY HH:mm:ss") : "Never"}
                </div>
              </div>
              <div className='users-item'>
                <div className='users-item-title'> Joined:</div>
                <div className='users-item-value'>
                  {moment.utc(user.created_on).local().format("DD.MM.YYYY HH:mm:ss")}
                </div>
              </div>
            </Link>
          ))}
      </div>
    );
  } else {
    content = <div className='no-content'>{noContentText}</div>;
  }
  return <div>{content}</div>;
}
